import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref, ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Heading,
  BaseText,
  Row,
  ChipStatus,
  BaseIcon,
  ToggleSwitch,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import {
  DetailsModal,
  TraderShield,
  DeallocateLimit,
  VariationModal,
  RecurringLimit
} from './components';

import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocationV2/helpers';

import {
  IMarginAllocationV2,
  IAmountDetails
} from '@/modules/trade/services/margin-allocation';

enum EButtonTypes {
  ALLOCATE = 'allocate',
  DEALLOCATE = 'deallocate',
  DISABLE_TRADER_SHIELD = 'disableTraderShield',
  HAS_POSITION = 'hasPosition',
  OPEN_VARIATION = 'openVariation'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DayTrade',
  setup(__props) {

const updatePreference = inject('fetchUpdatePreference', () => ({}));
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));

const dataForm = inject('dataForm') as Ref<{
  isUpdatingPreferences: boolean;
  isUpdatingTraderShield: boolean;
  isPreferencesSaved: boolean;
}>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const modalDetails = ref<IAmountDetails>();
const isDetailsModalOpen = ref(false);
const isTraderShieldOpen = ref(false);
const isEditMode = ref(false);
const isDeallocateOpen = ref(false);
const isVariationModalOpen = ref(false);
const isRecurringLimitOpen = ref(false);

const allocateButton = computed(() => {
  return marginAllocation.value.allocateButton;
});

const deallocateButton = computed(() => {
  return marginAllocation.value.deallocateButton;
});

const isTraderShieldEnabled = computed(
  () => marginAllocation.value.isTraderShieldEnabled
);

const details = computed(() => {
  return [
    marginAllocation.value.availableBalance,
    marginAllocation.value.dailyLoss
  ];
});

const traderShieldSubtitle = computed(() => {
  return isTraderShieldEnabled.value
    ? 'Proteção extra para suas operações'
    : 'Ative proteção extra para suas operações';
});

const traderShieldChip = computed(() => {
  return isTraderShieldEnabled.value
    ? {
        label: 'Ativo',
        status: 'positive'
      }
    : {
        label: 'Inativo',
        status: 'alert'
      };
});

function openTraderShield() {
  isEditMode.value = false;
  isTraderShieldOpen.value = true;
}

function handleClick(type: string, text: string) {
  switch (type as EButtonTypes) {
    case EButtonTypes.ALLOCATE:
      changeStep(EMarginAllocationSteps.BALANCE);
      break;

    case EButtonTypes.DEALLOCATE:
      isDeallocateOpen.value = true;
      break;

    case EButtonTypes.HAS_POSITION:
      notify({
        group: 'wrn-notifications',
        text: `Não é possível ${text} o limite, pois existem posições em aberto.`,
        type: NotificationTypes.error
      });
      break;

    case EButtonTypes.DISABLE_TRADER_SHIELD:
      isEditMode.value = true;
      isTraderShieldOpen.value = true;
      break;

    case EButtonTypes.OPEN_VARIATION:
      isVariationModalOpen.value = true;
      break;

    default:
      break;
  }
}

function handleModalOpen(details: IAmountDetails) {
  modalDetails.value = details;
  isDetailsModalOpen.value = true;
}

function handleInputPreference() {
  if (marginAllocation.value.isPreferencesSaved) return updatePreference();

  isRecurringLimitOpen.value = true;
}

return { __sfc: true,EButtonTypes, updatePreference, changeStep, dataForm, marginAllocation, modalDetails, isDetailsModalOpen, isTraderShieldOpen, isEditMode, isDeallocateOpen, isVariationModalOpen, isRecurringLimitOpen, allocateButton, deallocateButton, isTraderShieldEnabled, details, traderShieldSubtitle, traderShieldChip, openTraderShield, handleClick, handleModalOpen, handleInputPreference, NebraskaColors, Heading, BaseText, Row, ChipStatus, BaseIcon, ToggleSwitch, ButtonContainer, ButtonPrimary, ButtonSecondary, Money, DetailsModal, TraderShield, DeallocateLimit, VariationModal, RecurringLimit, EMarginAllocationSteps }
}

})